import { render, staticRenderFns } from "./v-pop-img.vue?vue&type=template&id=54cf91e9&scoped=true"
import script from "./v-pop-img.vue?vue&type=script&lang=js"
export * from "./v-pop-img.vue?vue&type=script&lang=js"
import style0 from "./v-pop-img.vue?vue&type=style&index=0&id=54cf91e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf91e9",
  null
  
)

export default component.exports